import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Typography, Container, makeStyles,
} from '@material-ui/core';
import seedLogo from '../images/logo.svg';
import MyLinearProgress from '../widgets/MyLinearProgress';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
  },
  content: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  logo: {
    marginBottom: theme.spacing(2),
    maxHeight: 100,
    width: 'auto',
  },
}));

const SeedLoadingPage = ({ logo }) => {
  const classes = useStyles();

  return (
    <Container disableGutters className={classes.container}>
      <MyLinearProgress isLoading />
      <div className={classes.content}>
        <img className={classes.logo} alt="Logo" src={logo} />
        <Typography variant="body2" color="textPrimary">
          <FormattedMessage id="seed.loading.text" />
        </Typography>
      </div>
    </Container>
  );
};

SeedLoadingPage.propTypes = {
  logo: PropTypes.string,
};

SeedLoadingPage.defaultProps = {
  logo: seedLogo,
};

export default SeedLoadingPage;
